import { gql } from '@apollo/client';

export const GET_ME = gql`
  query Me {
    me {
      id
      username
      lastName
      firstName
      displayName
      status
      email
      phone
      avatar
      billingStatus
      trialEndsAt
      currentPeriodEndsAt
      cancelAtPeriodEnd
      billingCustomerExternalId
      billingSubscriptionExternalId
    }
  }
`;

export interface MeUser {
  id: string;
  username?: string | null;
  lastName?: string | null;
  firstName?: string | null;
  displayName?: string | null;
  status?: string | null;
  email?: string | null;
  phone?: string | null;
  avatar?: string | null;
  billingStatus?: string | null;
  trialEndsAt?: string | null;
  currentPeriodEndsAt?: string | null;
  cancelAtPeriodEnd?: boolean | null;
  billingCustomerExternalId?: string | null;
  billingSubscriptionExternalId?: string | null;
}

export interface GetMeData {
  me?: MeUser | null;
}
